import * as React from "react";
import { ETLCodes } from "../locales";
import { useTl } from "../hooks";
import { Tooltip } from "@blueprintjs/core";
import styled from "styled-components";

export interface IInformationTooltipProps {
  tooltipMessage?: ETLCodes;
  customMessage?: string;
}

const StyledImage = styled.i`
  color: #1e90ff;
  size: 9px;
`;

export const InformationTooltip: React.FunctionComponent<IInformationTooltipProps> = ({
  tooltipMessage,
  customMessage = null,
}) => {
  const { t } = useTl();

  return (
    <Tooltip content={customMessage ?? t(tooltipMessage)}>
      <StyledImage className="fas fa-info-circle"/>
    </Tooltip>
  );
};
